import React from "react";
import { useTip } from "../ui/Tooltip/Tooltip";
import { CHART_COLORS } from "../../styles/theme";
import { fmtN } from "../../functions/format";

/**
 * Barres verticales groupées (2 séries).
 * labels : string[] ; series1 / series2 : number[]
 * names : [nom série 1, nom série 2] → active les tooltips "{nom} {label} : {valeur} {unit}"
 */
const VBars = ({
    labels = [],
    series1 = [],
    series2 = [],
    names,
    unit = "collab.",
    width = 440,
    height = 148,
}) => {
    const tip = useTip();
    const max = Math.max(...series1, ...series2) || 1;
    const gap = (width - 30) / labels.length;
    const bw = 12;

    const tipFor = (name, label, value) =>
        names ? `${name} ${label} : ${fmtN(value)} ${unit}` : undefined;

    return (
        <svg viewBox={`0 0 ${width} ${height}`} width="100%">
            {labels.map((label, i) => {
                const x = 24 + i * gap;
                const h1 = (series1[i] / max) * (height - 42);
                const h2 = (series2[i] / max) * (height - 42);
                return (
                    <g key={label}>
                        <rect
                            x={x}
                            y={height - 24 - h1}
                            width={bw}
                            height={h1}
                            rx="2.5"
                            fill={CHART_COLORS.violet}
                            {...tip(tipFor(names?.[0], label, series1[i]))}
                        />
                        <rect
                            x={x + bw + 3}
                            y={height - 24 - h2}
                            width={bw}
                            height={h2}
                            rx="2.5"
                            fill={CHART_COLORS.violetSoft}
                            {...tip(tipFor(names?.[1], label, series2[i]))}
                        />
                        <text
                            x={x + bw + 1.5}
                            y={height - 8}
                            textAnchor="middle"
                            fontSize="9"
                            fill={CHART_COLORS.muted2}
                        >
                            {label}
                        </text>
                    </g>
                );
            })}
        </svg>
    );
};

export default VBars;
